import { BOSToasterRef } from 'Components/Generic/BOSToaster';
import AppData from 'Data/AppData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext({
  isLoggedIn: false,
  userName: undefined,
});
AuthContext.displayName = 'AuthContext';

let DM = new DataManager();
export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(AppData.isLoggedIn());
  const [userName, setUserName] = useState(AppData.userFullName());

  useEffect(() => {
    DM.add(AppData.registerListener('USER_LOGGED_IN', handleLogIn), AppData);
    DM.add(AppData.registerListener('USER_LOGGED_OUT', handleLogOut), AppData);

    return () => {
      DM.clear();
    };
  }, []);

  const handleLogIn = () => {
    setIsLoggedIn(true);
    setUserName(AppData.userFullName());
  };

  const handleLogOut = () => {
    setIsLoggedIn(false);
    setUserName(undefined);
    BOSToasterRef.show({
      intent: 'success',
      icon: 'log-out',
      message: 'You have successfully logged out',
      timeout: 2000,
    });
  };

  const handleAuthChange = () => {
    setIsLoggedIn(AppData.isLoggedIn());
    setUserName(AppData.userFullName());
  };

  let auth = {
    isLoggedIn,
    userName,
    handleAuthChange,
    handleLogIn,
  };

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export const useAuthContext = () => useContext(AuthContext);
